import React, { useState } from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faXTwitter,
  faInstagram,
  faTiktok,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';


function Footer() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [visibleColumns, setVisibleColumns] = useState({
    contactUs: false,
  });


  const toggleColumnVisibility = (column) => {
    setVisibleColumns(prevState => ({
      ...prevState,
      [column]: !prevState[column]
    }));
  };

  const handleSubscribe = async () => {
    if (!email) {
      setMessage('Please enter a valid email.');
      return;
    }

    try {
      const response = await fetch('https://backend.indianjewelryish.com/api/user-subscribe', {  // Replace with your actual API endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      // console.log('Subscriber Data:',data);
      if (response.ok) {
        setMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setMessage(data.message || 'Subscription failed. Try again.');
      }
    } catch (error) {
      console.error('Subscription error:', error);
      setMessage('Something went wrong. Please try again later.');
    }
  };

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className='row'>
          <div className="col-sm-3 d-flex flex-column align-items-start px-4 my-4">
            <h1 className='footer-header'><i>Customer Service</i></h1>
            <Link className="footer-link" to={'/policies?id=1'}><span><i>Payment Policy</i></span></Link>
            <Link className="footer-link" to={'/policies?id=2'}><span><i>Shipping Policy</i></span></Link>
            <Link className="footer-link" to={'/policies?id=3'}><span><i>Return And Exchange Policy</i></span></Link>
            <Link className="footer-link" to={'/policies?id=4'}><span><i>Cancellation Policy</i></span></Link>
            <Link className="footer-link" to={'/policies?id=5'}><span><i>Frequently Asked Questions</i></span></Link>
            <Link className="footer-link" to={'/tac'}><span><i>Terms and Conditions</i></span></Link>
          </div>
          <div className="col-sm-3 d-flex flex-column align-items-start px-4 my-4">
            <h1 className='footer-header'><i>Quick Links</i></h1>
            <Link to='/' className="footer-link"><i>Home</i></Link>
            <Link to='/allproducts' className="footer-link"><i>Search</i></Link>
            <Link to='/aboutus' className="footer-link"><i>About Us</i></Link>
            <Link onClick={() => toggleColumnVisibility('contactUs')} className="footer-link"><i>Contact Us</i></Link>
            <div className={`footer-column ${visibleColumns.contactUs ? 'active' : ''}`}>
              <a href="mailto:indianjewelryish@gmail.com" className="header-contact_us-link footer-link"><i> Write e-mail to Us</i></a>
              <a href="tel:+919799279134" className="header-contact_us-link footer-link"><i>Call for Help</i></a>
              <a
                href="https://wa.me/+919799279134"
                target="_blank"
                rel="noopener noreferrer"
                className="header-contact_us-link footer-link"
              >
                <i>Chat with us on WhatsApp</i>
              </a>
            </div>
          </div>
          <div className="col-sm-6 d-flex flex-column px-4 my-4">
            <div className="d-flex flex-column">
              <h1 className='footer-header'><i>Subscribe for exclusive offers and updates.</i></h1>
              <div className="d-flex justify-content-center">
                <input
                  type="email"
                  className="form-control brand-email"
                  placeholder='Email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className='btn ml-2 brand-email-btn' onClick={handleSubscribe}>
                  <i>Subscribe</i>
                </button>
              </div>
              {message && <p className="text-center mt-2 text-muted">{message}</p>}
            </div>
            <div className="d-flex brand-icons justify-content-evenly mt-4">
              <a href="https://www.facebook.com/profile.php?id=61563907521069" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon className="icons" icon={faFacebook} />
              </a>
              <a href="javascript:void(0);" rel="noopener noreferrer">
                <FontAwesomeIcon className="icons" icon={faXTwitter} />
              </a>
              <a href="https://www.instagram.com/indian_jewelryish?igsh=enRyZng1ZWtvZ2Ns" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon className="icons" icon={faInstagram} />
              </a>
              <a href="javascript:void(0);" rel="noopener noreferrer">
                <FontAwesomeIcon className="icons" icon={faYoutube} />
              </a>

            </div>
          </div>
        </div>

      </div>

      <div className="copyright">
        &copy; 2025 Indian Jewelryish. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;
